import EnhancedPetitionDetails from "../../components/petitions/PetitionDetails/EnhancedPetitionDetails";

const PetitionDetailsPage = () => {
  return <EnhancedPetitionDetails />;
};

export default PetitionDetailsPage;
